import React from 'react'
import config from 'config'
import { LoginSelection } from 'components/login'

const IndexPage = (): JSX.Element => {
  return <LoginSelection selectionList={config.auth0.organizations} />
}

export default IndexPage
